var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.673 20.983a12.408 12.408 0 0 0 3.322-8.485c0-3.339-1.3-6.477-3.66-8.838A12.416 12.416 0 0 0 12.498 0c-2.545 0-4.993.76-7.08 2.198a.488.488 0 0 0 .553.804A11.455 11.455 0 0 1 12.498.977c3.077 0 5.97 1.198 8.146 3.374a11.446 11.446 0 0 1 3.375 8.147c0 3.077-1.199 5.97-3.375 8.146-.19.19-.19.5 0 .69l.459.459h-3.2v-3.207l.495.49c.191.19.5.189.69-.002a9.261 9.261 0 0 0 2.72-6.576 9.25 9.25 0 0 0-2.727-6.584 9.25 9.25 0 0 0-6.583-2.726c-5.134 0-9.31 4.176-9.31 9.31 0 2.486.968 4.824 2.726 6.583a9.249 9.249 0 0 0 6.584 2.727 9.27 9.27 0 0 0 4.428-1.12v1.593c0 .27.219.489.489.489h.306a11.452 11.452 0 0 1-5.223 1.249c-3.078 0-5.971-1.199-8.147-3.375a11.446 11.446 0 0 1-3.374-8.146c0-2.346.7-4.603 2.025-6.527a.488.488 0 1 0-.804-.554A12.427 12.427 0 0 0 0 12.497c0 3.339 1.3 6.477 3.66 8.838a12.416 12.416 0 0 0 8.838 3.66c2.565 0 5.023-.77 7.12-2.225h2.663a.488.488 0 0 0 .346-.834l-.954-.953zm-9.175-.152a8.28 8.28 0 0 1-5.893-2.44 8.279 8.279 0 0 1-2.44-5.893c0-4.596 3.737-8.334 8.333-8.334 2.225 0 4.318.867 5.892 2.44a8.279 8.279 0 0 1 2.441 5.894 8.282 8.282 0 0 1-2.102 5.532l-.97-.962a.488.488 0 0 0-.833.347v2.143a8.292 8.292 0 0 1-4.428 1.273z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.829 10.047a.592.592 0 0 0-.555-.382.593.593 0 0 0-.555.381l-1.76 4.621a.488.488 0 0 0 .913.348l.318-.836h2.154l.316.835a.488.488 0 1 0 .913-.345L9.83 10.047zm-1.267 3.155.71-1.864.704 1.864H8.562zM14.34 14.349h-.004l-.68.004v-4.2a.488.488 0 0 0-.976 0v4.684c0 .225.154.421.372.475.049.012.076.018.462.018.183 0 .446-.001.83-.004a.488.488 0 0 0-.004-.977zM18.068 14.833a.488.488 0 0 0-.488-.484h-.004l-.68.004v-4.2a.488.488 0 0 0-.977 0v4.684c0 .225.154.421.373.475.048.012.075.018.462.018.183 0 .446-.001.83-.004a.488.488 0 0 0 .484-.493z",
    fill: "#3CC"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3CC",
    cx: 4.006,
    cy: 4.006,
    r: 1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.d043d38a4107df25bdc1be3d1034cef1.svg";
export { ForwardRef as ReactComponent };